/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */

import { ChangePasswordRequest } from '../models/ChangePasswordRequest';
import { CreateUserRequest } from '../models/CreateUserRequest';
import { ResetPasswordRequest } from '../models/ResetPasswordRequest';
import { UpdateUserRequest } from '../models/UpdateUserRequest';
import { UserDto } from '../models/UserDto';
import { ApiError, catchGenericError } from '../core/ApiError';
import { request as __request } from '../core/request';
import { OpenAPI } from '../core/OpenAPI';

export class UserService {

    /**
     * Create user
     * @param requestBody
     * @result any
     * @throws ApiError
     */
    public static async userControllerCreate(
        requestBody: CreateUserRequest,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/user/create`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Show user info
     * @result UserDto
     * @throws ApiError
     */
    public static async userControllerInfo(): Promise<UserDto> {

        const result = await __request({
            method: 'get',
            path: `/api/user/info`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Update user
     * @param requestBody
     * @result UserDto
     * @throws ApiError
     */
    public static async userControllerUpdate(
        requestBody: UpdateUserRequest,
    ): Promise<UserDto> {

        const result = await __request({
            method: 'post',
            path: `/api/user/update`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Update user's password
     * @param requestBody
     * @result any
     * @throws ApiError
     */
    public static async userControllerChangePassword(
        requestBody: ChangePasswordRequest,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/user/change-password`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Verify user email
     * @param token
     * @result any
     * @throws ApiError
     */
    public static async userControllerVerifyEmail(
        token: string,
    ): Promise<any> {

        const result = await __request({
            method: 'get',
            path: `/api/user/verify-email`,
            query: {
                'token': token,
            },
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Request Password Reset
     * @param email
     * @result any
     * @throws ApiError
     */
    public static async userControllerRequestResetPassword(
        email: string,
    ): Promise<any> {

        const result = await __request({
            method: 'get',
            path: `/api/user/request-reset-password`,
            query: {
                'email': email,
            },
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Password Reset
     * @param token
     * @param requestBody
     * @result any
     * @throws ApiError
     */
    public static async userControllerResetPassword(
        token: string,
        requestBody: ResetPasswordRequest,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/user/reset-password`,
            query: {
                'token': token,
            },
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

}


// WEBPACK FOOTER //
// ./src/services/openapi/generated/services/UserService.ts